import { render, staticRenderFns } from "./AdjustmentStatusBadge.vue?vue&type=template&id=64036451&scoped=true"
import script from "./AdjustmentStatusBadge.vue?vue&type=script&lang=js"
export * from "./AdjustmentStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./AdjustmentStatusBadge.vue?vue&type=style&index=0&id=64036451&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64036451",
  null
  
)

export default component.exports